import React, { useState, useEffect } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";
import { useHistory } from "react-router-dom";
import { signOut } from "../../api/auth";
import { sendConfirmEmail } from "../../api/helpReq";

import OnboardingStepHeader from "./OnboardingStepHeader";
import Sallie from "../UIComponents/Sallie";
import SubmitButton from "../UIComponents/SubmitButton";

const EmailSent = ({ setOnboardingPercent, user, resetApp }) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setOnboardingPercent(90);
  }, []);

  // const clickHandler = () => {
  //   setSubmitting(true);
  //   history.push("/");
  // };
  // commented out - patient/caregiver button now logs the user out and sends them to /signIn instead of straight to "/"
  // Guard against the brief re-render where user is null: resetApp() (called
  // after the awaited sendConfirmEmail call) clears user before history.replace
  // navigates away, so this component can re-render mid-logout with user === null.
  if (!user) return null;

  // userType casing matches App.js: "Therapist" (capitalized), "provider" (lowercase)
  const isVerifyEmailUserType = ["Therapist", "provider"].includes(
    user.userType
  );

  const clickHandler = async () => {
    setSubmitting(true);
    // Therapists and providers additionally trigger the confirmation email send before logging out
    if (isVerifyEmailUserType) {
      try {
        await sendConfirmEmail({ email: user.email });
      } catch (err) {
        console.error("sendConfirmEmail error:", err);
      }
    }
    resetApp();
    signOut();
    history.replace("/signIn");
  };

  let SallieMsg = `${t("emailsent.sent_one")} ${user.email} ${t("emailsent.sent_two")}`;

  return (
    <>
      <OnboardingStepHeader text={t("emailsent.header")} />
      <Sallie text={SallieMsg} />
      <SubmitButton disabled={submitting} onClick={clickHandler}>
        {/* {user.userType !== "Therapist" ? t("emailsent.login") : t("emailsent.paynow")} */}
        {/* commented out - patient/caregiver now shows "Log Out" instead of "Log In" */}
        {/* Therapist/provider button now also logs out instead of routing to /PaymentPage - text updated to "Verify Email and Log out" */}
        {isVerifyEmailUserType ? t("emailsent.paynow") : t("emailsent.logout")}
      </SubmitButton>
    </>
  );
};

export default EmailSent;